import { render } from "./SettingsComponent.vue?vue&type=template&id=6e126d7f&scoped=true"
import script from "./SettingsComponent.vue?vue&type=script&lang=js"
export * from "./SettingsComponent.vue?vue&type=script&lang=js"

import "./SettingsComponent.vue?vue&type=style&index=0&id=6e126d7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e126d7f"]])

export default __exports__